import React from 'react';
import { FaFacebookF, FaInstagram, FaTwitter, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TopBar2 = () => {
  const { user } = useAuth();
  const phoneNumber = user?.phoneNumber || '+1 (800) 555-TRIP';
  const email = user?.email || 'hello@yourtravelco.com';
  
  const styles = {
    topBarContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: 'var(--topbar-bg-color, #1a1a1a)', // Very dark background
      color: 'var(--topbar-text-color, #e0e0e0)', // Light grey text for readability
      padding: '12px 30px',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      fontSize: '14px',
    },
    // Sections for left and right content
    section: {
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
    },
    // The standout central CTA block
    ctaBlock: {
      backgroundColor: 'var(--accent-color, #fecb00)', // Vibrant yellow accent
      color: '#1a1a1a', // Dark text on the yellow background
      padding: '8px 20px',
      borderRadius: '20px',
      fontWeight: 'bold',
      whiteSpace: 'nowrap', // Prevents text from wrapping
    },
    // Styling for social media icons
    socialLink: {
      color: 'inherit', // Inherits the light grey color from the container
      textDecoration: 'none',
      transition: 'color 0.3s ease',
    },
    // Styling for individual contact items on the right
    contactItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      color: 'inherit',
      textDecoration: 'none',
    },
    // A subtle vertical line to separate contact info
    divider: {
      width: '1px',
      height: '16px',
      backgroundColor: '#555',
    },
  };

  return (
    <div style={styles.topBarContainer}>
      {/* Left Side: Social Media Icons */}
      <div style={styles.section}>
        <a href="#" style={styles.socialLink}><FaFacebookF size={16} /></a>
        <a href="#" style={styles.socialLink}><FaInstagram size={16} /></a>
        <a href="#" style={styles.socialLink}><FaTwitter size={16} /></a>
      </div>

      {/* Center: Call-to-Action Block */}
      <div style={styles.ctaBlock}>
        <span>Early Bird Deals End Soon!</span>
      </div>

      {/* Right Side: Contact Information */}
      <div style={styles.section}>
        <a href={`tel:${phoneNumber}`} style={styles.contactItem}>
          <FaPhoneAlt size={14} />
          <span>{phoneNumber}</span>
        </a>
        <div style={styles.divider}></div> {/* Visual Separator */}
        <a href={`mailto:${email}`} style={styles.contactItem}>
          <FaEnvelope size={14} />
          <span>{email}</span>
        </a>
      </div>
    </div>
  );
};

export default TopBar2;